import { Link } from 'react-router-dom'
import { Zap, Mail, MapPin, ArrowUpRight } from 'lucide-react'
import { pillarLinks } from '@/data/pillarPages'

const SERVICES_LINKS = pillarLinks

const COMPANY_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/#system', label: 'How It Works' },
  { to: '/services', label: 'Capabilities' },
  { to: '/blog', label: 'Blog' },
  { to: '/brand-manifesto', label: 'Brand Manifesto' },
  { to: '/contact', label: 'Contact' },
]

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-white/10 bg-dark-950">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="mb-4 flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-brand-500 to-accent-500">
                <Zap className="h-4 w-4 text-white" />
              </div>
              <span className="font-display text-xl font-bold text-white">
                ANVI <span className="text-brand-400">Solutions</span>
              </span>
            </Link>
            <p className="max-w-md text-sm leading-relaxed text-white/60">
              ANVI helps US brands get found, understood, and trusted across AI search with a
              service-led visibility program powered by a connected MCP operating layer.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/50">
              <a href="mailto:hello@anvisolutions.com" className="flex items-center gap-2 transition-colors hover:text-brand-400">
                <Mail className="h-4 w-4" /> hello@anvisolutions.com
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4" /> Serving brands across the United States
              </div>
            </div>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Capabilities</h3>
            <ul className="space-y-2">
              {SERVICES_LINKS.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="group flex items-center gap-1 text-sm text-white/50 transition-colors hover:text-brand-400">
                    {label}
                    <ArrowUpRight className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Company</h3>
            <ul className="space-y-2">
              {COMPANY_LINKS.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-white/50 transition-colors hover:text-brand-400">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs text-white/30">© {year} ANVI Solutions. All rights reserved.</p>
          <p className="text-xs text-white/30">AI visibility systems for the answer-engine era.</p>
        </div>
      </div>
    </footer>
  )
}
